import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import { CloseIcon } from "@icarius-icons";
import Loader from "@icarius-common/loader";
import DialogTransition from "@icarius-common/dialogTransition";
import Form from "./form";
import { getLocalizedString } from "@icarius-localization/strings";


const CreateEditDialog = (props) => {

    const getTypeName = (type) => {
        switch (type) {
            case "S":
                return getLocalizedString("suggestionLowercase");
            case "D":
                return getLocalizedString("reportLowercase");
            case "R":
                return getLocalizedString("complaintLoweracase");
            case "C":
                return getLocalizedString("queryLowerCase");
            default:
                return getLocalizedString("thirdPartyReportLowercase");
        }
    }

    const {
        open,
        data,
        type,
        isLoading,
        handleAfterCreateCallback,
        handleClose,
    } = props;

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            open={open}
            PaperComponent={PaperDraggable}
            maxWidth={'md'}
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {`${Boolean(data) ? getLocalizedString("editRequest") : getLocalizedString("create")} ${getTypeName(type)}`}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent style={{ paddingTop: 0 }}>
                <Loader open={isLoading} />
                <Form
                    type={type || "T"}
                    typeString={getTypeName(type)}
                    data={data}
                    handleClose={handleClose}
                    handleAfterCreateCallback={handleAfterCreateCallback}
                />
            </DialogContent>
        </Dialog>
    )
}

export default CreateEditDialog;